export const BALANCE_LEVELS = {
  ARRAY: 'Array',
  STRING: 'String',
  PACK: 'Battery Pack',
}
